var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "url(#paint0_linear_842_2566)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9514 6.50436C19.8411 6.39739 19.71 6.31247 19.5655 6.25453C19.4209 6.19658 19.2659 6.16675 19.1094 6.16675C18.9528 6.16675 18.7978 6.19658 18.6533 6.25453C18.5088 6.31247 18.3776 6.39739 18.2674 6.50436L9.43233 15.019L5.72042 11.4351C5.60595 11.3287 5.47082 11.245 5.32276 11.1888C5.17469 11.1327 5.01658 11.1051 4.85745 11.1078C4.69833 11.1104 4.5413 11.1432 4.39534 11.2043C4.24938 11.2653 4.11734 11.3535 4.00677 11.4636C3.8962 11.5738 3.80925 11.7039 3.7509 11.8464C3.69255 11.9889 3.66393 12.141 3.66669 12.2942C3.66944 12.4473 3.70351 12.5985 3.76695 12.7389C3.83038 12.8794 3.92195 13.0065 4.03642 13.1129L8.59033 17.4958C8.70057 17.6028 8.83174 17.6877 8.97625 17.7456C9.12077 17.8036 9.27577 17.8334 9.43233 17.8334C9.58888 17.8334 9.74389 17.8036 9.8884 17.7456C10.0329 17.6877 10.1641 17.6028 10.2743 17.4958L19.9514 8.18219C20.0718 8.0753 20.1678 7.94559 20.2335 7.8012C20.2992 7.65682 20.3332 7.5009 20.3332 7.34328C20.3332 7.18565 20.2992 7.02973 20.2335 6.88535C20.1678 6.74096 20.0718 6.61125 19.9514 6.50436Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_2566",
    x1: 29.3778,
    y1: 8.25002,
    x2: -2,
    y2: 8.25002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxChecked);
export default __webpack_public_path__ + "static/media/check_box_checked.17b836390cc428949974fcae1ac89baf.svg";
export { ForwardRef as ReactComponent };